<style scoped>
  .ivu-title{
    color:#464c5b;
    font-size:12px;
    font-weight: bold;
  }
  .lan{
    color:#464c5b;
    font-size:12px;
    font-weight: bold;
  }
</style>
<template>
  <div style="background-color: #f8f8f8;min-height: 100%;padding:10px;">

    <Card  :bordered="false" dis-hover style="margin-bottom:10px;">
      <div style="text-align:left">
        <a @click="load">刷新</a>
        <cite>|</cite>
        <router-link to="/emailedit">
          <a>增加</a>
        </router-link>
        <cite>|</cite>
          <a @click="modal2=true">批量增加</a>
        <cite>|</cite>
        <a @click="removeall">删除全部</a>
        <cite>|</cite>
        <a @click="modal1=true">查看变量规则</a>
      </div>
    </Card>

    <Card  :bordered="false" dis-hover style="margin-bottom:10px;" v-if="list.length==0">
      暂无数据
    </Card>

    <Card  :bordered="false" dis-hover style="margin-bottom:10px;" v-for="item in list">
      <div style="float:left;" class="ivu-title">
       {{item.name}}<cite>|</cite>
        <span v-html="item.title"></span>
      </div>
      <div style="float: right;max-width: 150px">
        <router-link :to="'/emailedit?id='+item.id">
          <a>编辑</a>
        </router-link>
        <cite>|</cite>
        <router-link :to="'/emailprev?id='+item.id">
          <a>预览</a>
        </router-link>
        <cite>|</cite>
        <a @click="remove(item.id)">删除</a>
      </div>
      <div style="clear: both"></div>
    </Card>

    <Modal
      v-model="modal1"
      title="规则说明"
      @on-ok="ok"
      @on-cancel="cancel">
      <span class="lan">E0312_CURRENT_EMAIL</span><cite>-</cite>替换当前收件箱（包含@后面部分）<br/>
      <span class="lan">E0313_CURRENT_EMAILUSER</span><cite>-</cite>替换当前收件箱（不包含@后面部分）<br/>
      <span class="lan">E0314_UUID</span><cite>-</cite>生成32位随机英文+数字字符<br/>
      <span class="lan">E0315_RANDOM_STR</span><cite>-</cite>生成1-20个随机汉字<br/>
      <!--<span class="lan">%EBP_1_EBP%</span><cite>-</cite>替换随机变量 1 表示 变量的ID-->
    </Modal>

    <Modal
      v-model="modal2"
      title="批量导入邮件"
      @on-ok="savef"
      @on-cancel="cancel">
      <Alert type="error">提示：附件名称必须包含一个'：'符号，否则无法正常上传</Alert>
      <Upload
        :on-success="uploadSuccess"
        :on-remove="uploadRemove"
        multiple="true"
        type="drag"
        action="/api/upload/upload">
        <div style="padding: 20px 0">
          <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
          <p>仅支持.eml后缀的邮箱</p>
        </div>
      </Upload>
    </Modal>

  </div>
</template>

<script>
  export default {
    data(){
      return{
        modal1:false,
        list:[],
        modal2:false,//批量增加
        fids:[],
      }
    },
    methods:{
      load(){
        let that = this;
        this.$axios.get('/api/email/findall').then(function(rs){
          that.list = rs.data;
          that.$Message.success('加载成功');
        });
      },
      removeall(){
        this.$Modal.confirm({
          title: '系统提示',
          content: '确定要删除全部邮件吗（不可恢复）',
          onOk: () => {
            let that = this;
            this.$axios.get('/api/email/deleteall').then(function(rs){
              that.toast(rs.data);
            });
          },
        });
      },
      remove(id){
        this.$Modal.confirm({
          title: '系统提示',
          content: '确定要删除吗（不可恢复）',
          onOk: () => {
            let that = this;
            this.$axios.get('/api/email/delete?ids='+id).then(function(rs){
              that.toast(rs.data);
            });
          },
        });
      },
      uploadSuccess( response, file, fileList){
        this.fids.push(response.upload.id);
        this.$Message.success('上传成功');
      },
      uploadRemove(file, fileList){
        let id = file.response.upload.id;
        for(let i = 0;i<this.fids.length;i++){
          if(id===this.fids[i]){
            this.fids.splice(i,1);
          }
        }
      },
      savef(){//保存附件
        if(this.fids.length==0){
          this.$Message.warning('请上传邮件');
          return;
        }
        let that = this;
        this.$axios.get('/api/email/savef?fids='+this.fids).then(function(rs){
          that.toast(rs.data);
        });
      },
      toast(data){
        if(data.success){
          this.$Message.success(data.msg);
          this.load();
        }else{
          this.$Message.error(data.msg);
        }
      }
    },
    created(){
      this.load();
    }

  }
</script>



// WEBPACK FOOTER //
// src/components/email/Email.vue